/**
 * Public Cortex-for-Host API client — Glasbrenner-Cockpit-Fix (23.09.2026).
 * Resolves a Cockpit hostname to the Cortex origin the frontend should talk
 * to: a tenant's own dedicated instance if one is provisioned, otherwise the
 * shared IT-SCE instance. Ersetzt den bisher build-time hardcodeten
 * `VITE_CORTEX_URL` (immer https://cortex.it-sce.de) durch eine
 * Runtime-Aufloesung, analog `realmHostApi.ts`.
 *
 * Unauthenticated — gleiche Konvention wie realmHostApi.ts/idpResolveApi.ts.
 */
import type { AxiosError } from 'axios'
import { createApiClient } from '../lib/apiClient'


const SHARED_CORTEX_URL = 'https://cortex.it-sce.de'

const client = createApiClient({
  timeout: 8000,
  headers: { 'Content-Type': 'application/json' },
})

export interface CortexForHostResponse {
  cortex_url: string
  dedicated: boolean
}

export const CortexHostAPI = {
  /**
   * Resolve the Cortex origin for a Cockpit hostname.
   * GET /api/public/cortex-for-host?host=<hostname> -> { cortex_url, dedicated }
   * Fail-safe: jeder Fehler (Netzwerk, 404, leere Antwort) faellt auf die
   * geteilte Instanz zurueck — nie ein White-Screen, nie ein kaputter Chat.
   */
  async resolve(host: string): Promise<string> {
    try {
      const res = await client.get<CortexForHostResponse>(
        '/public/cortex-for-host',
        { params: { host } }
      )
      const url = res.data?.cortex_url?.trim()
      return url || SHARED_CORTEX_URL
    } catch (error) {
      const axiosError = error as AxiosError
      // eslint-disable-next-line no-console
      console.warn('Cortex-Host-Auflösung fehlgeschlagen, falle auf geteilte Instanz zurück:', axiosError.message)
      return SHARED_CORTEX_URL
    }
  },
}
